import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { ConfigService } from 'src/app/services/config.service';
import { ThirdPartyService } from 'src/app/third-party/third-party.service';

@Component({
  selector: 'app-unique-identifier',
  templateUrl: './unique-identifier.component.html',
  styleUrls: ['./unique-identifier.component.scss']
})
export class UniqueIdentifierComponent implements OnInit{
  subscription = new Subscription;
  ChangeSellerDomainFrom!: FormGroup;
  OtpForm!: FormGroup;
  isEditingSubDomain: boolean = false;
  invalidError: boolean = false;
  isSubdomainAvailable: boolean = false;
  isSubdomainUnavailable: boolean = false;
  domainOptions = [
    { label: 'bazaarnear.com', value: 'bazaarnear.com' },
    { label: 'tobeonline.in', value: 'tobeonline.in' },
    { label: 'weareonline.in', value: 'weareonline.in' },
  ];
  isShowOtpForm: boolean = false;
  storeUrl: string = "";
  userDetails: any;

  interval: any
  countdown!: number
  intervalVariable: any;
  lastThreeDigits: string = '';

  constructor(private adminService: AdminService,
      public configService: ConfigService,
      private thirdPartyService: ThirdPartyService,
      private fb: FormBuilder,
    ) {}

  ngOnInit(): void {
    this.userDetails = this.adminService.getLoginDetails();
    this.ChangeSellerDomainFrom = this.fb.group({
      subDomainName: ["", [Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
      domain: [""]
    });

    this.OtpForm = this.fb.group({
      otp: ["", [Validators.required]]
    });

    this.splitDomainAndSubdomain();
  }

  onEditClicked() {
      this.isEditingSubDomain = true;
    }
  
    onSubdomainChange(event: Event) {
      this.invalidError = false
      const subDomain = (event.target as HTMLInputElement).value;
      if (subDomain === this.userDetails.SubDomain) {
        this.isSubdomainAvailable = true;
        this.isSubdomainUnavailable = false;
        return;
      }
      if (subDomain) {
        this.adminService.checkSubdomainExist(subDomain).subscribe((res: any) => {
          if (res?.Result === "Success") {
            if (res?.ResponseData === "Already") {
              this.isSubdomainAvailable = false;
              this.isSubdomainUnavailable = true;
            } else if (res?.ResponseData === "Not Exist") {
              this.isSubdomainAvailable = true;
              this.isSubdomainUnavailable = false;
              this.SetStoreUrl();
            }
          } else {
            this.isSubdomainAvailable = false;
            this.isSubdomainUnavailable = false;
          }
        }, (error: HttpErrorResponse) => {
          console.error('Error checking subdomain existence:', error);
          this.isSubdomainAvailable = false;
          this.isSubdomainUnavailable = false;
        });
      } else {
        this.isSubdomainAvailable = false;
        this.isSubdomainUnavailable = false;
      }
    }
  
    onDomainChange(event: any): void {
      this.ChangeSellerDomainFrom.patchValue({ domain: event.value });
      this.isSubdomainAvailable = true;
      this.isSubdomainUnavailable = false;
      this.SetStoreUrl();
    }
  
    GenerateOtp() {
      if (!this.isSubdomainAvailable) {
        this.configService.notify({ severity: 'error', summary: 'Failed', detail: `Store Name not available` });
      } else {
        this.subscription.add(this.adminService.GenerateOTPforAdmin().subscribe((res: any) => {
          if (res.Result == "Success") {
            this.isShowOtpForm = true
            this.getlastthreedigitofPhonenumber()
            this.countDown()
          }
          else {
            this.configService.notify({ severity: 'error', summary: 'Failed', detail: `OTP request failed` });
          }
        },
          (error: HttpErrorResponse) => {
  
            console.log('--------------------')
            console.log(error)
            console.log('--------------------')
          }));
      }
  
    }
  
    onVerifyClicked() {
      if (this.OtpForm.valid) {
        clearInterval(this.intervalVariable)
        this.countdown = 0
        let params = {
          PhoneNumber: this.userDetails.UserName,
          OTP: this.OtpForm.controls['otp'].value
        }
        this.subscription.add(this.adminService.compareOTPWithStringReturn(params).subscribe((res: any) => {
          if (res.Result == "Success" && res.ResponseData == "Success") {
            this.ChangeSellerSubdomin()
          } else {
            this.configService.notify({ severity: 'error', summary: 'Failed', detail: `Invalid OTP` });
          }
  
        },
          (error: HttpErrorResponse) => {
            console.log('--------------------')
            console.log(error)
            console.log('--------------------')
          }
        ));
      }
    }
  
    onCancelClicked() {
      this.isEditingSubDomain = false;
      
      this.isSubdomainAvailable = false;
      this.isSubdomainUnavailable = false;
      this.invalidError = false;
    }
  
    ChangeSellerSubdomin() {
      let subDomain = this.ChangeSellerDomainFrom.get('subDomainName')?.value
      let domain = this.ChangeSellerDomainFrom.get('domain')?.value
      if (subDomain === this.userDetails.SubDomain) {
        this.isSubdomainAvailable = true
      }
  
      if (!this.isSubdomainAvailable) {
        this.configService.notify({ severity: 'error', summary: 'SuccFailedess', detail: `Store Name not available` });
      } else if (!this.ChangeSellerDomainFrom.get('subDomainName')?.value) {
        this.invalidError = true
        this.configService.notify({ severity: 'error', summary: 'Failed', detail: `Enter a Valid Store Name` });
      } else {
        let params = {
          subDomainPath: subDomain + "." + domain,
        };
        this.adminService.changeSellerSubdomain(params).subscribe((res: any) => {
          if (res.Result == "Success" && res.ResponseData != "Failed") {
            this.configService.getSettingsBySellerId();
            let adminDetails = JSON.parse(localStorage.getItem('admin_Details') || '{}');
            if (adminDetails) {
              adminDetails.SubDomain = params.subDomainPath;
              localStorage.setItem('admin_Details', JSON.stringify(adminDetails));
            }
            this.SetStoreUrl();
            this.isShowOtpForm = false
            this.OtpForm.reset();
            this.isSubdomainAvailable = false;
            this.isEditingSubDomain = false;
            this.configService.notify({ severity: 'success', summary: 'Success', detail: `Store Name saved` });
            window.location.reload();
          } else {
            this.configService.notify({ severity: 'success', summary: 'Success', detail: `Store Name Change Failed` });
          }
        });
      }
    }
  
    SetStoreUrl() {
      const subDomainName = this.ChangeSellerDomainFrom.get('subDomainName')?.value;
      const domain = this.ChangeSellerDomainFrom.get('domain')?.value;
  
      if(this.ChangeSellerDomainFrom.invalid){
        return;
      }
      
      if (subDomainName && domain) {
        const storeUrl = `https://${subDomainName}.${domain}`;
        this.storeUrl = storeUrl;
      } else {
        const storeUrl = `https://${subDomainName}`;
        this.storeUrl = storeUrl;
      }
  
      
    }
  
    private splitDomainAndSubdomain() {
      const urlParts = this.userDetails.SubDomain.split('.');
      if (urlParts.length >= 2) {
        const subDomain = urlParts[0];
        const domain = urlParts.slice(1).join('.');
        this.ChangeSellerDomainFrom.patchValue({
          subDomainName: subDomain,
          domain: domain,
        });
      }
      this.SetStoreUrl();
    }

    countDown() {
    this.countdown = 30
    this.intervalVariable = setInterval(() => {
      this.countdown--
      if (this.countdown < 1) {
        clearInterval(this.intervalVariable)
      }
    }, 1000)

  }

  getlastthreedigitofPhonenumber() {
    if (this.userDetails && this.userDetails.UserName) {
      const mobileNumber = this.userDetails.UserName;
      this.lastThreeDigits = mobileNumber.slice(-3);
    }
  }
}
